export const links = {
    linkedinNewsletterSubscribe: "https://www.linkedin.com/newsletters/testing-insider-7358808842782060545/",
}